export const REQUEST_PUBLISH_DATA = 'REQUEST_PUBLISH_DATA';
export const PUBLISH_DATA_RECEIVED = 'PUBLISH_DATA_RECEIVED';